<template>
  <AppLayout>
    <template #middle>
      <DashboardContent />
    </template>
    <template #outside>
      <ProgramCriteriasModal />
      <ProfileDescriptionModal />
      <ProfilePictureModal />
    </template>
  </AppLayout>
</template>

<script setup lang="ts">
import AppLayout from '@/(routes)/(protected)/(app)/layout.vue'
import DashboardContent from '@/features/ui/pages/dashboard/dashboard-content/dashboard-content.vue'
import ProgramCriteriasModal from '@/features/ui/pages/dashboard/dashboard-content/mentor/program-criterias-modal/program-criterias-modal.vue'
import ProfileDescriptionModal from '@/features/auth/components/profile-description-modal/profile-description-modal.vue'
import ProfilePictureModal from '@/features/auth/components/profile-picture-modal/profile-picture-modal.vue'
</script>
